import axios from 'axios';
import { offlineEnabled, graceValidToday, isCacheableGet, writeCache, readCache } from '../utils/offlineCache';
import { markOnline, markNetFail } from '../utils/netStatus';

const baseURL = String(process.env.REACT_APP_API_URL || '/api').trim() || '/api';

const api = axios.create({
    baseURL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('pos_token');
        // Açıq verilmiş real token (offline növbə sinxronu) 'offline' placeholder ilə əvəzlənməsin
        const explicit = String(config.headers?.Authorization || '');
        if (token && !(explicit.startsWith('Bearer ') && String(config.url || '').includes('/sync/'))) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
            delete config.headers['content-type'];
        }

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => {
        markOnline(); // server cavab verdi → online (navigator.onLine-dan asılı olmayan etibarlı siqnal)
        // Offline rejim açıqdırsa → whitelist GET cavablarını keşlə (online davranış dəyişmir)
        try {
            if (offlineEnabled() && isCacheableGet(response.config?.method, response.config?.url)) {
                writeCache(response.config.url, response.data);
            }
        } catch { /* ignore */ }
        return response;
    },
    (error) => {
        const url = error.config?.url || '';
        if (error.response) markOnline(); else markNetFail(); // cavab varsa server əlçatan; yoxdursa şəbəkə xətası
        // 401 = server cavab verdi → onlayn → re-login yönləndirməsi düzgündür (C#-da da işləsin).
        // /sync/ (fon) və /auth/ istisnadır ki, refresh döngüsü olmasın.
        let offlineSess = false;
        try { offlineSess = !!(JSON.parse(localStorage.getItem('pos_user') || 'null') || {})._offlineLogin; } catch { /* ignore */ }
        if (error.response?.status === 401 && !url.includes('/auth/') && !url.includes('/sync/') && !offlineSess) {
            localStorage.removeItem('pos_token');
            localStorage.removeItem('pos_user');
            const waiterToken = localStorage.getItem('pos_waiter_token');
            window.location.href = waiterToken ? `/?t=${waiterToken}` : '/';
            return Promise.reject(error);
        }
        // Şəbəkə xətası (internet gedib) + offline rejim + lisenziya BU GÜN keçib → keşdən qaytar.
        // Qeyd: güzəşt stale (sabah) olsa → keş verilmir, online tələb olunur (ödənişdən yayınma qarşısı).
        if (!error.response && offlineEnabled() && graceValidToday() && isCacheableGet(error.config?.method, url)) {
            const cached = readCache(url);
            if (cached != null) {
                return Promise.resolve({ data: cached, status: 200, __fromCache: true, config: error.config });
            }
        }
        return Promise.reject(error);
    }
);

export default api;
